import React from "react";
import "./css/Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-content">
        <h6>© Copyright - Aniqa Johnson Counselling | Darren Nelson Designs</h6>
      </div>
    </div>
  );
};

export default Footer;
